import { canonical, newsArticleSchema } from "@utils";
import connectionsMixins from "~/plugins/mixins/nyt-connections";

export default {
	name: "NYTConnectionsToday",
	mixins: [connectionsMixins],
	head() {
		return {
			title: this.$route.meta.title,
			link: [canonical(this.$route)],
			script: [
				newsArticleSchema({
					headline: this.metaTitleMonthAndDay,
					image: "https://wordfinder.yourdictionary.com/static/images/nyt-connections-og.jpg",
					datePublished: "2023-11-21T08:00:00.000Z",
					author: { type: "Person", name: "Carrie Grosvenor" },
				}),
			],
		};
	},
	data() {
		return {
			todaysRevealed: false,
		};
	},
};
